// 화면에 보이는 키 안내 글(순수). 터치 기기에서는 키보드 글자 대신 손가락 조작 문구를 쓴다(페르소나 QA ④).
import type { KeyPreset } from '../shared/keymap';

/** 타이틀 안내 줄(키 배치별, 터치면 손가락 조작) */
export function titleKeyText(p: KeyPreset, touch = false): string {
  if (touch) return '왼쪽을 끌어 이동 · 오른쪽 버튼으로 공격·스킬·회피·각성 · 두 손가락으로 시야 조절 · 위 단추로 일시정지·설정';
  const dodge = p === 'rpg' ? 'Shift 회피' : 'K 회피';
  const win = p === 'rpg' ? 'K 스킬 · C 스탯 · ' : '';
  return 'WASD 이동 · J 공격 · ' + dodge + ' · U/I/O/L/P 스킬 · Space 각성 · 휠/+- 카메라 · F 전체 화면 · Q 자동 진행 · ' + win + 'G 퀘스트 · F1 단축키 · Esc 일시정지';
}
/** 일시정지 창 안내(키 배치별, 터치면 손가락 조작) */
export function pauseKeyText(p: KeyPreset, touch = false): string {
  if (touch) return '왼쪽을 끌어 이동 · 오른쪽 버튼으로 공격·스킬·회피·각성\n두 손가락 벌리기·좁히기 시야 · 카메라 단추로 시야 초기화';
  const dodge = p === 'rpg' ? 'Shift 회피' : 'K 회피';
  const cam = p === 'rpg' ? 'Home 카메라 초기화' : 'C 카메라 초기화';
  const win = p === 'rpg' ? ' · K 스킬 · C 스탯' : '';
  return 'WASD 이동 · J 공격 · ' + dodge + ' · U/I/O/L/P 스킬\nSpace 각성 · 휠/+- 시야 · ' + cam + ' · F 전체 화면' + win + ' · Esc 일시정지';
}
/** 퀘스트 추적기 설정 설명(G 키는 PC 문구) */
export function questTrackerHelp(touch: boolean): string {
  return '마을 왼쪽의 작은 퀘스트 추적기를 보이거나 숨깁니다. 퀘스트 창은 가방 줄의 「퀘스트」 단추' + (touch ? '로' : '나 G 키로') + ' 언제든 열 수 있어요';
}
/** 콤보 길잡이 단계 키 글자를 화면에 낼지: 슬롯 번호(1~6)는 터치 슬롯에도 있어 남기고, J·A1 같은 키보드 글자만 터치에서 숨긴다 */
export function comboKeyVisible(key: string, touch: boolean): boolean {
  return !touch || /^[1-6]$/.test(key);
}
